<h1 mat-dialog-title [attr.data-cy]="'sgsdgsd_h1_1_4_'"
    >Schweinegruppe {{ input?.gruppe?.gruppe_id ? "bearbeiten" : "erstellen" }}</h1
>
<div mat-dialog-content>
    <!--<h4 style="width: 100%">
        {{ input?.kunde?.bezeichnung_final }} {{ input?.kunde?.zusatz_final }}
    </h4>-->

    <mat-form-field style="width: 100%; margin: 0 0 -1em" *ngIf="showAbschnittStallAbteil()">
        <mat-label>Produktionsabschnitt</mat-label>
        <mat-select
            [formControl]="produktionsabschnittCtrl"
            [compareWith]="produktionsabschnittComparator"
            [attr.data-cy]="'sgsdgsd_mat-select_1_1_'"
        >
            <mat-option
                *ngFor="let p of produktionsabschnitte; let i = index"
                [value]="p"
                [attr.data-cy]="'sgsdgsd_option_1_' + i"
            >
                {{ p.produktionsabschnitt }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <div *ngIf="!isMobile">
        <div class="one-row">
            <kiene-autocomplete
                *ngIf="input?.kunde_id && showAbschnittStallAbteil()"
                #standortAutocomplete
                (deleteSelected)="deleteStall($event)"
                (elementSelected)="setStandort($event)"
                [displayFields]="['stall', 'sgs_nummer']"
                separator=", "
                [panelWidth]="'16%'"
                [emitFreeText]="true"
                [focus]="true"
                [genericApiUrl]="apiBaseUrl + 'gruppe/read_stall.php'"
                [kieneObject]="stall"
                [params]="params"
                [placeholder]="'Stall *'"
                [showClear]="false"
                [showDeleteButton]="true"
                style="width: 32%; margin: 0 0 -1em"
            >
            </kiene-autocomplete>

            <mat-form-field style="width: 32%; margin: 0 0 -1em" *ngIf="showAbschnittStallAbteil()">
                <mat-label>Abteil</mat-label>
                <input [formControl]="abteilCtrl" matInput type="text" [attr.data-cy]="'sgsdgsd_input_1_1_'" />
            </mat-form-field>

            <mat-form-field style="width: 32%; margin: 0 0 -1em">
                <mat-label>Gruppenname</mat-label>
                <input [formControl]="gruppennameCtrl" matInput type="text" [attr.data-cy]="'sgsdgsd_input_2_1_'" />
            </mat-form-field>
        </div>

        <ng-container *ngIf="showAnzahlDatumGewicht()">
            <div class="one-row">
                <mat-form-field style="width: 32%; margin: 0 0 -1em">
                    <mat-label>Anzahl Tiere</mat-label>
                    <input
                        [formControl]="anzahlTiereCtrl"
                        matInput
                        type="number"
                        [attr.data-cy]="'sgsdgsd_input_3_1_'"
                    />
                </mat-form-field>

                <mat-form-field style="width: 32%; margin: 0 0 -1em">
                    <mat-label>Einstalldatum</mat-label>
                    <input
                        [formControl]="einstalldatumVonCtrl"
                        [matDatepicker]="einstalldatum_von"
                        [readonly]="true"
                        matInput
                        [attr.data-cy]="'sgsdgsd_input_4_1_'"
                    />
                    <mat-datepicker-toggle [for]="einstalldatum_von" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #einstalldatum_von></mat-datepicker>
                </mat-form-field>

                <ng-container *ngIf="!input?.gruppe?.gruppe_id">
                    <mat-form-field style="width: 32%; margin: 0 0 -1em">
                        <mat-label>Einstallgewicht <small>pro Tier (kg)</small></mat-label>
                        <input
                            [formControl]="einstallgewichtProTierCtrl"
                            matInput
                            type="number"
                            [attr.data-cy]="'sgsdgsd_input_5_1_'"
                        />
                    </mat-form-field>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <div *ngIf="isMobile" style="font-size: 75%">
        <kiene-autocomplete
            *ngIf="input?.kunde_id && showAbschnittStallAbteil()"
            (deleteSelected)="deleteStall($event)"
            (elementSelected)="setStandort($event)"
            [displayFields]="['stall', 'sgs_nummer']"
            separator=", "
            [emitFreeText]="true"
            [focus]="true"
            [genericApiUrl]="apiBaseUrl + 'gruppe/read_stall.php'"
            [kieneObject]="stall"
            [params]="params"
            [placeholder]="'Stall *'"
            [showClear]="false"
            [showDeleteButton]="true"
            style="width: 32%; margin: 0 0 -1em"
        >
        </kiene-autocomplete>

        <mat-form-field style="width: 100%; margin: 0 0 -1em" *ngIf="showAbschnittStallAbteil()">
            <mat-label>Abteil</mat-label>
            <input [formControl]="abteilCtrl" matInput type="text" [attr.data-cy]="'sgsdgsd_input_6_1_'" />
        </mat-form-field>

        <mat-form-field style="width: 100%; margin: 0 0 -1em">
            <mat-label>Gruppenname</mat-label>
            <input [formControl]="gruppennameCtrl" matInput type="text" [attr.data-cy]="'sgsdgsd_input_7_1_'" />
        </mat-form-field>

        <ng-container *ngIf="showAnzahlDatumGewicht()">
            <mat-form-field style="width: 100%; margin: 0 0 -1em">
                <mat-label>Anzahl Tiere</mat-label>
                <input [formControl]="anzahlTiereCtrl" matInput type="number" [attr.data-cy]="'sgsdgsd_input_8_1_'" />
            </mat-form-field>

            <mat-form-field style="width: 100%; margin: 0 0 -1em">
                <mat-label>Einstalldatum</mat-label>
                <input
                    [formControl]="einstalldatumVonCtrl"
                    [matDatepicker]="einstalldatum_von"
                    [readonly]="true"
                    matInput
                    [attr.data-cy]="'sgsdgsd_input_9_1_'"
                />
                <mat-datepicker-toggle [for]="einstalldatum_von" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #einstalldatum_von></mat-datepicker>
            </mat-form-field>

            <ng-container *ngIf="!input?.gruppe?.gruppe_id">
                <mat-form-field style="width: 100%; margin: 0 0 -1em">
                    <mat-label>Einstallgewicht <small>pro Tier (kg)</small></mat-label>
                    <input
                        [formControl]="einstallgewichtProTierCtrl"
                        matInput
                        type="number"
                        [attr.data-cy]="'sgsdgsd_input_10_1_'"
                    />
                </mat-form-field>
            </ng-container>
        </ng-container>
    </div>
    <ng-container *ngIf="showAnzahlDatumGewicht()">
        <div class="one-row">
            <b>Herkunftsbetrieb (opt.)</b>
            <button
                mat-icon-button
                color="accent"
                (click)="openHerkunftsBetriebDialog()"
                [attr.data-cy]="'sgsdgsd_button_1_0_'"
            >
                <mat-icon [attr.data-cy]="'sgsdgsd_mat-icon_1_2_'">edit</mat-icon>
            </button>
            <button
                *ngIf="kundeHerkunft"
                mat-icon-button
                color="accent"
                (click)="deleteHerkunftsbetrieb()"
                [attr.data-cy]="'sgsdgsd_button_2_0_'"
            >
                <mat-icon [attr.data-cy]="'sgsdgsd_mat-icon_2_2_'">delete</mat-icon>
            </button>
        </div>
        <h3 [attr.data-cy]="'sgsdgsd_h3_1_'" *ngIf="kundeHerkunft"
            >{{ kundeHerkunft.bezeichnung }} {{ kundeHerkunft.zusatz }}</h3
        >
    </ng-container>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button (click)="close()" mat-button [attr.data-cy]="'sgsdgsd_button_3_0_'">Abbrechen</button>
    <button
        (click)="save()"
        color="accent"
        mat-flat-button
        [disabled]="!isFormValid()"
        [attr.data-cy]="'sgsdgsd_button_4_0_'"
        >{{ !input?.gruppe?.gruppe_id ? "Erstellen" : "Bearbeiten" }}
    </button>
</div>
